import * as MutationTypes from './mutationTypes';

const userSettingsSuccess = (state, payload) => {
  state.userSettings = payload;
};

export const mutations = {
  [MutationTypes.USER_SETTINGS_SUCCESS]: userSettingsSuccess,
};
